var _defs, _metadata, _rect, _path, _g, _path2, _g2, _g3, _g4, _circle, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1027 831",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:23.4582}\r\n    .str3 {stroke:black;stroke-width:23.4582;stroke-linecap:round}\r\n    .str1 {stroke:black;stroke-width:23.4582;stroke-linecap:round}\r\n    .str2 {stroke:black;stroke-width:23.4582;stroke-linecap:round;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil5 {fill:black}\r\n    .fil1 {fill:#996633}\r\n    .fil4 {fill:white}\r\n    .fil3 {fill:white;fill-rule:nonzero}\r\n    .fil2 {fill:white;fill-opacity:0.501961}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514 155c-33,0 -224,7 -334,243 -133,286 116,322 334,321 218,0 466,-34 333,-321 -110,-236 -300,-243 -333,-243z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_211450000"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1027,
    height: 831
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M514 155c-33,0 -224,7 -334,243 -133,286 116,322 334,321 218,0 466,-34 333,-321 -110,-236 -300,-243 -333,-243z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil2",
    d: "M515 864c142,0 257,-79 257,-176 0,-97 -115,-176 -257,-176 -143,0 -258,79 -258,176 0,97 115,176 258,176z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M514 155c-33,0 -224,7 -334,243 -133,286 116,322 334,321 218,0 466,-34 333,-321 -110,-236 -300,-243 -333,-243z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M453 483l-47 0 0 0 0 -2 0 -3 -1 -2 0 -2 0 -2 -1 -2 0 -1 -1 -2 -1 -2 -1 -2 -1 -1 0 -2 -1 -2 -2 -1 -1 -2 -1 -1 -1 -1 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -2 -1 -1 0 -2 -1 -1 0 -2 -1 -1 0 -2 0 -1 -1 -2 0 0 -47 4 1 4 0 5 1 4 0 4 1 4 2 3 1 4 2 4 1 3 2 4 2 3 3 3 2 3 3 3 3 3 2 2 4 3 3 2 3 2 3 2 4 2 3 2 4 1 4 2 4 1 4 1 4 1 4 1 4 0 4 0 4 1 5 0 0zm-81 86l0 -47 0 0 2 0 1 0 2 0 1 -1 2 0 1 -1 2 0 1 -1 2 0 1 -1 2 -1 1 -1 1 -1 2 -1 1 -1 1 -2 1 -1 1 -2 2 -1 1 -2 0 -1 1 -2 1 -2 1 -1 1 -2 0 -2 1 -2 0 -2 0 -2 1 -2 0 -2 0 -2 47 0 -1 4 0 4 0 4 -1 5 -1 4 -1 4 -1 4 -2 4 -1 3 -2 4 -2 4 -2 3 -2 3 -2 4 -3 3 -2 3 -3 3 -3 3 -3 2 -3 3 -3 2 -4 2 -3 2 -4 2 -4 1 -3 2 -4 1 -4 1 -4 1 -5 0 -4 1 -4 0 0 0zm-81 -86l47 0 0 0 0 2 0 2 1 2 0 2 0 2 1 2 0 2 1 2 1 1 1 2 1 2 1 1 1 2 1 1 1 2 1 1 1 2 1 1 2 1 1 1 1 1 2 1 1 1 2 0 1 1 2 0 1 1 2 0 1 1 2 0 1 0 2 0 0 47 -4 0 -4 -1 -5 0 -4 -1 -4 -1 -4 -1 -3 -2 -4 -1 -4 -2 -3 -2 -4 -2 -3 -2 -3 -3 -3 -2 -3 -3 -3 -3 -2 -3 -3 -3 -2 -4 -2 -3 -2 -3 -2 -4 -2 -4 -1 -3 -2 -4 -1 -4 -1 -4 -1 -4 -1 -5 0 -4 0 -4 -1 -4 0 0zm81 -87l0 47 0 0 -2 0 -1 1 -2 0 -1 0 -2 1 -1 0 -2 1 -1 0 -2 1 -1 1 -2 1 -1 1 -1 1 -2 1 -1 1 -1 1 -1 1 -1 2 -1 1 -1 2 -1 2 -1 1 -1 2 -1 2 -1 2 0 1 -1 2 0 2 0 2 -1 2 0 3 0 2 -47 0 1 -5 0 -4 0 -4 1 -4 1 -4 1 -4 1 -4 2 -4 1 -4 2 -4 2 -3 2 -4 2 -3 2 -3 3 -3 2 -4 3 -2 3 -3 3 -3 3 -2 3 -3 4 -2 3 -2 4 -1 4 -2 3 -1 4 -2 4 -1 4 0 5 -1 4 0 4 -1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M372 420c32,0 57,28 57,63 0,34 -25,62 -57,62 -32,0 -57,-28 -57,-62 0,-35 25,-63 57,-63z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 388,
    cy: 484,
    r: 52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M575 483l0 0 0 -5 0 -4 1 -4 0 -4 1 -4 1 -4 2 -4 1 -4 2 -4 1 -4 2 -3 2 -4 2 -3 3 -3 2 -3 3 -4 3 -2 2 -3 3 -3 4 -2 3 -3 3 -2 4 -2 3 -1 4 -2 4 -1 4 -2 4 -1 4 0 4 -1 4 0 4 -1 0 47 -1 0 -2 1 -1 0 -2 0 -2 1 -1 0 -2 1 -1 0 -1 1 -2 1 -1 1 -2 1 -1 1 -1 1 -2 1 -1 1 -1 1 -1 2 -1 1 -1 2 -1 2 -1 1 -1 2 0 2 -1 2 -1 1 0 2 -1 2 0 2 0 2 0 3 0 2 0 0 -47 0zm80 86l0 0 -4 0 -4 -1 -4 0 -4 -1 -4 -1 -4 -1 -4 -2 -4 -1 -3 -2 -4 -2 -3 -2 -3 -2 -4 -3 -3 -2 -2 -3 -3 -3 -3 -3 -2 -3 -3 -4 -2 -3 -2 -3 -2 -4 -1 -4 -2 -3 -1 -4 -2 -4 -1 -4 -1 -4 0 -5 -1 -4 0 -4 0 -4 47 0 0 2 0 2 0 2 0 2 1 2 0 2 1 2 1 2 0 1 1 2 1 2 1 1 1 2 1 1 1 2 1 1 1 2 2 1 1 1 1 1 2 1 1 1 2 1 1 0 1 1 2 0 1 1 2 0 2 1 1 0 2 0 1 0 0 0 0 47zm81 -86l0 0 0 4 0 4 -1 4 -1 5 0 4 -1 4 -2 4 -1 4 -2 3 -1 4 -2 4 -2 3 -2 3 -3 4 -2 3 -3 3 -3 3 -3 3 -3 2 -3 3 -3 2 -3 2 -4 2 -4 2 -3 1 -4 2 -4 1 -4 1 -4 1 -4 0 -4 1 -5 0 0 -47 2 0 2 0 1 0 2 -1 1 0 2 -1 1 0 2 -1 1 0 2 -1 1 -1 1 -1 2 -1 1 -1 1 -1 2 -2 1 -1 1 -2 1 -1 1 -2 1 -1 1 -2 1 -2 0 -1 1 -2 1 -2 0 -2 0 -2 1 -2 0 -2 0 -2 0 -2 0 0 47 0zm-81 -87l0 0 5 1 4 0 4 1 4 0 4 1 4 2 4 1 3 2 4 1 4 2 3 2 3 3 3 2 3 3 3 3 3 2 3 4 2 3 3 3 2 3 2 4 2 3 1 4 2 4 1 4 2 4 1 4 0 4 1 4 1 4 0 4 0 5 -47 0 0 -2 0 -3 0 -2 -1 -2 0 -2 0 -2 -1 -1 -1 -2 0 -2 -1 -2 -1 -1 -1 -2 -1 -2 -1 -1 -1 -2 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -1 -1 -2 -1 -1 -1 -2 0 -1 -1 -2 0 -1 -1 -2 0 -1 0 -2 -1 -2 0 0 0 0 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M655 420c-31,0 -57,28 -57,63 0,34 26,62 57,62 32,0 58,-28 58,-62 0,-35 -26,-63 -58,-63z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 640,
    cy: 484,
    r: 52
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_211452280"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 624,
    cy: 483,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 403,
    cy: 483,
    r: 20
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_211451632"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M513 591c0,40 4,8 0,47 -7,60 -197,69 -209,-38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M515 591c0,40 -5,8 0,47 6,60 197,69 208,-38"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 514,
    cy: 586,
    r: 37
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_211449592"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil4 str2",
    d: "M348 664c14,31 27,85 42,116 9,17 45,16 43,-7l-4 -91c-35,-2 -57,-8 -81,-18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4 str2",
    d: "M679 664c-14,31 -28,85 -42,116 -9,17 -45,16 -44,-7l5 -91c35,-2 57,-8 81,-18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str3",
    d: "M314 596c0,0 -74,13 -167,72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str3",
    d: "M360 626c0,0 -93,34 -200,132"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str3",
    d: "M402 651c0,0 -56,43 -108,133"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str3",
    d: "M713 596c0,0 74,13 167,72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str3",
    d: "M667 626c0,0 93,34 199,132"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str3",
    d: "M625 651c0,0 56,43 108,133"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni6);
export default __webpack_public_path__ + "static/media/ani6.01a1ce57a860c87c7f6047448b7769ca.svg";
export { ForwardRef as ReactComponent };